import { h } from "preact";
import { useState, useContext, useEffect } from "preact/hooks";
import { SimpleReferralWidgetContext } from "../index";
import Cookies from "js-cookie";
import {
  calculateForeground,
  traceWidgetLoad
} from "../../../internal_utilities/utilities";

const SignUpForm = ({ isFormVisible, onClose }) => {
  const simpleReferralWidgetContext = useContext(SimpleReferralWidgetContext);
  const [name, setName] = useState(
    window.Shopify.checkout.billing_address
      ? window.Shopify.checkout.billing_address.first_name
      : ""
  );
  const [email, setEmail] = useState(
    window.Shopify.checkout.email ? window.Shopify.checkout.email : ""
  );
  const [isError, setIsError] = useState(false);

  const highlightColor = simpleReferralWidgetContext.currentCampaign
    .thankyouPageConfig.popupThemeColor
    ? simpleReferralWidgetContext.currentCampaign.thankyouPageConfig
        .popupThemeColor
    : simpleReferralWidgetContext.currentCampaign.thankyouPageConfig.bgEndColor;

  const handleFormSubmit = async e => {
    e && e.preventDefault();
    if (window.isPreviewPage === true) {
      const giftDetails = {
        campaign: simpleReferralWidgetContext.currentCampaign,
        code: "TEST-CODE",
        name: name
      };
      simpleReferralWidgetContext.viewStateHistory.goTo(
        "share-view",
        giftDetails
      );
    } else {
      traceWidgetLoad({
        name: "form_submited",
        domain: window.Shopify.shop,
        url: window.location.href,
        referrer: document.referrer || "",
        key: ["app_name", "widget_type"],
        value: [
          "offerscorner",
          simpleReferralWidgetContext.currentCampaign.type
        ],
        operatingSystem: window.navigator.userAgentData
          ? window.navigator.userAgentData.platform
          : window.navigator.platform,
        screenSize: window.screen
          ? `${window.screen.width}-${window.screen.height}`
          : "",
        browserVersion: window.navigator.userAgentData
          ? window.navigator.userAgentData.brands[0].version
          : "",
        browser: window.navigator.userAgentData
          ? window.navigator.userAgentData.brands[0].brand
          : ""
      });
      try {
        let data = await window.fetch(
          `${process.env.REACT_APP_STARLINK_URL}/audience/${
            window.Shopify.shop
          }/campaign/${
            simpleReferralWidgetContext.currentCampaign.campaignId
          }/join`,
          {
            method: "POST",
            body: JSON.stringify({
              audience: {
                email: email,
                name: name,
                campaignType: "SIMPLE_REFERRAL",
                order: {
                  id: JSON.stringify(window.Shopify.checkout.order_id)
                },
                customerId: JSON.stringify(window.Shopify.checkout.customer_id)
              }
            }),
            headers: {
              "Content-Type": "application/json"
            }
          }
        );
        const responce = await data.json();
        const giftDetails = {
          campaign: simpleReferralWidgetContext.currentCampaign,
          code: responce.code,
          name: name
        };
        if (responce.code) {
          Cookies.set(
            `ofco-existing-referrer-${
              simpleReferralWidgetContext.currentCampaign.campaignId
            }`,
            JSON.stringify(giftDetails),
            {
              sameSite: "lax",
              secure: true
            }
          );
          simpleReferralWidgetContext.viewStateHistory.goTo(
            "share-view",
            giftDetails
          );
        } else {
          setIsError(true);
        }
      } catch (err) {
        console.log(err);
      }
    }
  };

  // If email and name is avalable, popup is skipped
  useEffect(
    () => {
      if (isFormVisible && name && email) {
        handleFormSubmit();
      }
    },
    [isFormVisible]
  );

  return (
    <div
      id="coca-email-popup-wrapper"
      className={`absolute bg-black/10 flex flex-col w-full h-full items-stretch  ${
        isFormVisible
          ? "coca-form-visible opacity-100 pointer-events-auto transition"
          : "coca-form-invisible opacity-0 pointer-events-none transition"
      }`}
    >
      <a
        id="coca-email-bg-close-area"
        onClick={() => onClose()}
        className=" w-full opacity-0 p-0 m-0 grow"
      />
      <div
        id="coca-email-popup"
        className={` rounded shadow-lg m-2 bg-white px-3 pt-4 transition -translate-y-40 ${isFormVisible &&
          "translate-y-0 pointer-events-auto"}`}
      >
        {/* <p className="coca-mb-2">
          {simpleReferralWidgetContext.currentLanguage &&
          simpleReferralWidgetContext.currentLanguage.email_form_text
            ? simpleReferralWidgetContext.currentLanguage.email_form_text
            : "The updated coupon codes will be send to the following email address that you submit"}
        </p> */}
        {!isError ? (
          <form
            id="coca-simple-referral-email-form"
            className=" flex flex-col items-stretch"
            onSubmit={handleFormSubmit}
          >
            <input
              className="coca-email-form-input border border-solid border-gray-200 px-4 py-5 mb-4 border text-sm rounded-lg"
              id="coca-name-input"
              placeholder={
                simpleReferralWidgetContext.currentLanguage &&
                simpleReferralWidgetContext.currentLanguage
                  .email_form_name_placeholder
                  ? simpleReferralWidgetContext.currentLanguage
                      .email_form_name_placeholder
                  : "Name"
              }
              type="text"
              required
              value={name}
              onClick={() => {
                document.getElementById("coca-name-input").focus();
              }}
              onChange={e => setName(e.target.value)}
            />
            <input
              id="coca-email-input"
              className="coca-email-form-input border border-solid border-gray-200 px-4 py-5 mb-4 border text-sm rounded-lg"
              placeholder={
                simpleReferralWidgetContext.currentLanguage &&
                simpleReferralWidgetContext.currentLanguage
                  .email_form_email_placeholder
                  ? simpleReferralWidgetContext.currentLanguage
                      .email_form_email_placeholder
                  : "Email"
              }
              type="email"
              required
              value={email}
              onClick={() =>
                document.getElementById("coca-email-input").focus()
              }
              onChange={e => setEmail(e.target.value)}
            />
            <button
              id="coca-simple-referral-form-submit-button"
              className=" coca-thank-big-button p-4 rounded-md cursor-pointer text-base grow w-full w-full px-4 py-5 mb-4 border text-sm "
              ref={node => {
                if (node)
                  node.style.setProperty(
                    "background",
                    `${highlightColor}`,
                    "important"
                  );
              }}
              type="submit"
            >
              <span
                ref={node => {
                  if (node)
                    node.style.setProperty(
                      "color",
                      `${
                        calculateForeground(highlightColor) === "white"
                          ? "rgba(255,255,255,1)"
                          : "rgba(0,0,0,.6)"
                      }`,
                      "important"
                    );
                }}
              >
                {" "}
                <b>
                  {simpleReferralWidgetContext.currentLanguage &&
                  simpleReferralWidgetContext.currentLanguage.email_form_cta
                    ? simpleReferralWidgetContext.currentLanguage.email_form_cta
                    : "Get coupon code"}
                </b>
              </span>
            </button>
          </form>
        ) : (
          <div
            id="coca-simple-referral-form-failed"
            className="coca-email-form flex flex-col items-stretch"
          >
            <p className="text-center">Action Failed</p>
            <button
              onClick={() => handleFormSubmit}
              className="  coca-thank-big-button p-4 rounded-md cursor-pointer text-base grow w-full px-4 py-5 mb-4 border text-sm "
              ref={node => {
                if (node)
                  node.style.setProperty(
                    "background",
                    `${highlightColor}`,
                    "important"
                  );
              }}
              type="submit"
            >
              <span
                ref={node => {
                  if (node)
                    node.style.setProperty(
                      "color",
                      `${
                        calculateForeground(highlightColor) === "white"
                          ? "rgba(255,255,255,1)"
                          : "rgba(0,0,0,.6)"
                      }`,
                      "important"
                    );
                }}
              >
                {" "}
                <b>Try Again</b>
              </span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SignUpForm;
